export const ListAndDetailSamplesCustomRenderPageInfo = () => {
  return (
    <>
        You can customise how each list item is rendered.<br />
        This example adds a city icon and makes the option blue if it's a UK city/town.
    </>
  )
}
